import orgModuleMutations from "./orgModule/mutations";
import adminModuleMutations from "./adminModule/mutations";
import vendorModuleMutations from "./vendorModule/mutations";

const setPrescriberLookup = (state, payload) => {
  state.prescribers = payload;
};

export default {
  ...orgModuleMutations,
  ...adminModuleMutations,
  ...vendorModuleMutations,
  setPrescriberLookup,
};
